const apiurl = process.env.REACT_APP_API_URL;
export const API_BASE_URL = apiurl;
export const API_CONFIGS = { API_BASE_URL };
